import { Block } from "@app/blocks/Blocks";
import AllInOneImg from "@assets/footer/img-all-in-one.png";
import { subscribeCTALink } from "@components/Footer/constant";

export default function FooterSubscribeRow(): React.ReactElement {
  return (
    <Block rootClassName="bg-gray-250 py-6 w-full">
      <div className="container" data-testid="footer-subscribe-row">
        <div className="flex flex-wrap">
          <div className="w-full px-3 lg:w-8/12">
            <h4 className="mb-1 text-center font-poppins text-3xl font-bold lg:text-left lg:text-4xl">
              SUPPORT SOUTH-EAST ASIA&#39;S LEADING FINANCIAL DAILY
            </h4>
            <p className="text-center lg:text-left">
              Get the latest coverage and full access to all BT premium content.
            </p>
            <a
              className="transition-al mx-auto mb-5 block w-8/10 rounded-full border border-orange-300 bg-orange-300 px-4 py-2 text-center font-poppins text-base font-semibold !text-white !no-underline duration-300 ease-in-out hover:bg-white hover:!text-orange-300 lg:inline-block lg:w-auto"
              href={subscribeCTALink.footer}
            >
              SUBSCRIBE NOW
            </a>
            <p className="mb-0 text-center font-public-sans font-medium lg:text-left">
              {"Browse corporate subscription "}
              <a
                className="font-lct font-semibold !text-black hover:underline"
                href="https://subscribe.sph.com.sg/corporate-plans/"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
            </p>
          </div>
          <div className="hidden w-full px-3 lg:block lg:w-4/12">
            <img
              className="mx-auto"
              src={AllInOneImg}
              width="222"
              height="141"
              alt="The Business Times"
            />
          </div>
        </div>
      </div>
    </Block>
  );
}
